<template>
    <div class="accordion-body collapse" :id="'auto_payment_'+account.PersonAccountId">
        <div class="accordion-body__inner edm-connect block">
            <div class="edm-connect__close">
                <a :href="'#auto_payment_'+account.PersonAccountId" class="button-icon button-icon--th-primary" data-toggle="collapse"><i class="icon icon--close"></i></a>
            </div>
            <div class="edm-connect__left">
                <div class="edm-connect__title">
                    <span> Как работает автоплатёж? </span>
                </div>
                <h5 class="edm-connect__descr">
                    В случае успешной авторизации Вы получите уведомление от сайта о том, что оплата проведена и/или описание порядка получения товара/услуги.
                </h5>
                <div class="edm-connect__text">
                    <p>Вулканическое стекло формирует разлом. Белок стереоспецифично полимеризует глетчерный голоцен. В противоположность этому электролиз ослаблен.</p>
                    <p>В литературе неоднократно описано, как геотемпературная аномалия варьирует кайнозой. Эта разница, вероятно, помогает объяснить, почему дайка сменяет силл. Эта разница, вероятно, помогает объяснить, почему конус выноса наклонно испускает атом, и это неудивительно, если вспомнить синергетический характер явления. Трог, так же, как и в других регионах, обедняет токсичный исток, что получается при взаимодействии с нелетучими кислотными оксидами.</p>
                    <p>Выпадение смещает увалистый тектогенез. Уравнение, в рамках ограничений классической механики, структурно слагает водоносный этаж. В слабопеременных полях (при флуктуациях на уровне единиц процентов) индуцированное соответствие полимеризует основной соленосный артезианский бассейн путем взаимодействия с гексаналем и трехстадийной модификацией интермедиата. Зандровое поле огромно. Напряженность магнитного поля Земли, если рассматривать процессы в рамках специальной теории относительности, переоткладывает электронный горст.</p>
                    <p class="status-error">Вулканическое стекло формирует разлом. Белок стереоспецифично полимеризует глетчерный голоцен. В противоположность этому электролиз ослаблен.</p>
                    <p class="status-error">Вулканическое стекло формирует разлом. Белок стереоспецифично полимеризует глетчерный голоцен. В противоположность этому электролиз ослаблен.</p>
                    <p>Вулканическое стекло формирует разлом. Белок стереоспецифично полимеризует глетчерный голоцен. В противоположность этому электролиз ослаблен.</p>
                    <p>Вулканическое стекло формирует разлом. Белок стереоспецифично полимеризует глетчерный голоцен. В противоположность этому электролиз ослаблен.</p>
                </div>
            </div>
            <div class="edm-connect__right">
                <div class="edm-connect__item autopay__head">
                    <div class="edm-connect__row">
                        <div class="h2">
                            Подключение автоплатежа к ЛС №
                        </div>
                        <div class="edm-connect__number">
                            {{account.AccountNumber}}
                        </div>
                    </div>
                    <h5 class="edm-connect__name edm-connect__subtitle">
                        Управляейте вашим бюджетом, установив частоту, дату и размер списания
                    </h5>
                </div>
                <div class="edm-connect__steps js-checkox-container">
                    <div class="autopay__table autopay__item">
                        <div class="autopay-table__item">
                            <div class="b-select">
                                <div class="b-select__label text-bold">Периодичность списания</div>
                                <select class="b-select__picker selectpicker" data-style-base="button">
                                    <option value="">1</option>
                                    <option value="">2</option>
                                    <option value="">3</option>
                                </select>
                            </div>
                        </div>
                        <div class="autopay-table__item">
                            <label class="txt-input">
                                <div class="txt-input__label text-bold">Подключение с</div>
                                <div class="txt-input__input">
                                    <input class="txt-input__field input js-period-picker-days req" type="text">
                                    <div class="txt-input__icon fab-icon">
                                        <i class="icon icon--calendar"></i>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div class="autopay-table__item">
                            <div class="b-select__label text-bold">Дата списания</div>
                            <label class="txt-input autopay__input autopay__input-block">
                                <div class="txt-input__label">Дата 1 списания:</div>
                                <div class="txt-input__input">
                                    <input class="txt-input__field input req" type="number" value="10" min="1" max="31">
                                    <div class="txt-input__required txt-input__required--error">Неверно указана дата</div>
                                </div>
                            </label>
                            <label class="txt-input autopay__input autopay__input-block">
                                <div class="txt-input__label">Дата 2 списания:</div>
                                <div class="txt-input__input">
                                    <input class="txt-input__field input req" type="number" value="20" min="1" max="31">
                                    <div class="txt-input__required txt-input__required--error">Неверно указана дата</div>
                                </div>
                            </label>
                        </div>
                        <div class="autopay-table__item">
                            <label class="txt-input autopay__input-block">
                                <div class="txt-input__label text-bold">Сумма списания, руб</div>
                                <div class="txt-input__input">
                                    <input class="txt-input__field input req" type="number">
                                </div>
                            </label>
                            <label class="txt-input autopay__input-block">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input" disabled value="Остаток списания" type="text">
                                </div>
                            </label>
                        </div>
                        <div class="autopay-table__item">
                            <div class="b-select">
                                <div class="b-select__label text-bold">Списание с карты</div>
                                <select class="b-select__picker selectpicker" data-style-base="button">
                                    <option value="">**** **** **** 1234</option>
                                    <option value="">**** **** **** 2345</option>
                                    <option value="">**** **** **** 3456</option>
                                </select>
                            </div>
                        </div>
                        <div class="autopay-table__item">
                            <label class="txt-input">
                                <div class="txt-input__label text-bold">Максимальная сумма списания в месяц</div>
                                <div class="txt-input__input">
                                    <input class="txt-input__field input" type="number">
                                </div>
                            </label>
                        </div>
                        <div class="autopay-table__item">
                            <div class="b-select">
                                <div class="b-select__label text-bold">Среднемесячное начисление по ЛС за последние 6 мес.</div>
                            </div>
                        </div>
                        <div class="autopay-table__item">
                            <div class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input" disabled value="2 736,12" type="text">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="autopay__item text-bold">Дата последнего успешного списания - 1700р. (10.11.2021)</div>
                    <div class="autopay__item">В соответствии с требованиями ФЗ-54 от 22.05.2003г., электронная версия кассового чека будет направлена на адрес электронной почты</div>
                    <div class="autopay__subfooter autopay__item">
                        <div class="line-form__check line-form__col line-form__col--agree">
                            <label class="cb-input">
                                <input class="cb-input__checkbox input req" type="checkbox" data-type="checkbox">
                                <span class="cb-input__check"></span>
                                <span class="cb-input__label"><a href="" class="link link--underline"><span class="link__text">С порядком и условиями оплаты, зачисления и возврата денежных средств согласен.</span></a></span>
                            </label>
                        </div>
                        <div class="autopay__mail">
                            <div class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input" type="mail" data-type="email" value="info@email.ru" disabled>
                                    <div class="txt-input__required txt-input__required--error">Неверно указан адрес Email</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="autopay__item autopay__footer">
                        <a href="#" class="button button--th-second _light autopay__button">Подключить</a>
                        <a href="#" class="button button--th-second _light autopay__button">Возобновить</a>
                        <a href="#" class="button button--th-second _light autopay__button">Приостановить</a>
                        <a href="#" class="button button--th-second _light autopay__button">Сохранить</a>
                        <a href="#" class="button button--th-second _light autopay__button">Изменить</a>
                    </div>
                </div>
                <!-- сообщение после проверки кода -->
                <div class="edm-connect__message" style="display: none;">
                    <div class="edm-connect__message-title">
                        Заявка на подключение принята 11.05.2021 14:56
                    </div>
                    <div class="edm-connect__message-text">
                        Благодарим Вас за переход на безбумажную технологию обмена финансовыми документами через ЭДО.<br /> Все измененя вступят в силу с 1 числа следующего месяца. <br /> В дальнейшем Вы будете ежемесячно получать от нас документы в электронном виде.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'account-autopayment',
        props: {
            account: Object
        },

    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-autopayment.vue